import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ContributionInput = ({ onSubmit }) => {
  const [inputText, setInputText] = useState('');

  const handleSubmit = () => {
    if (inputText?.trim()) {
      onSubmit?.(inputText);
      setInputText('');
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="fixed bottom-6 left-0 right-0 z-40 px-6">
      {/* Floating Pill Container */}
      <div
        className="max-w-[600px] mx-auto rounded-full flex items-center gap-2 px-4 h-[60px]"
        style={{
          backgroundColor: '#FDFCFA',
          border: 'none',
          boxShadow: '0 8px 24px rgba(197, 160, 89, 0.15)'
        }}
      >
        {/* Circular Submit Button (Far Left for RTL) */}
        <button
          onClick={handleSubmit}
          disabled={!inputText?.trim()}
          className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center transition-all duration-300"
          style={{
            backgroundColor: '#C5A059',
            border: 'none'
          }}
          aria-label="إرسال"
        >
          <Icon name="Send" size={16} color="white" />
        </button>

        {/* Transparent Input Field */}
        <textarea
          value={inputText}
          onChange={(e) => setInputText(e?.target?.value)}
          onKeyPress={handleKeyPress}
          placeholder="أضف صوتك إلى الدائرة..."
          className="flex-1 resize-none py-0"
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
            fontFamily: 'Amiri, serif',
            fontSize: '14px',
            color: '#2C2B29',
            minHeight: '28px',
            maxHeight: '100px',
            direction: 'rtl',
            boxShadow: 'none',
            lineHeight: '1.5'
          }}
        />
      </div>

      {/* Placeholder Styling */}
      <style jsx>{`
        textarea::placeholder {
          color: #888888;
          font-family: 'Amiri', serif;
        }
      `}</style>
    </div>
  );
};

export default ContributionInput;